import React from 'react';
import Loading from 'app/ui/core/common/Loading';
import './style/CenteredLoader.scss';

export default function CenteredLoader({
  fullScreen,
  fullScreenFlex,
  children,
}) {
  const classes = ['CenteredLoader'];
  if (fullScreen) {
    classes.push('CenteredLoader--FullScreen');
  }
  if (fullScreenFlex) {
    classes.push('CenteredLoader--FullScreenFlex');
  }
  return <div className={classes.join(' ')}>{children || <Loading />}</div>;
}
